import { render } from "./Accordian.vue?vue&type=template&id=18ad83eb"
import script from "./Accordian.vue?vue&type=script&lang=js"
export * from "./Accordian.vue?vue&type=script&lang=js"

import exportComponent from "/root/projects/website/vue-notus-main/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__